module.exports = "/static/banner_dati.jpg";